export const plEnumNum = 0;
export const engEnumNum = 1;
export const filterDebouseTime = 500;